const SigmaSquadAbout = () => {
    return(
        <div>
            <h2 className="about-text">
                About
            </h2>
            <div className="sep1"></div>
            <div className="SSAbout">
                <p>
                    Welcome to IIT Tirupati's Artifical Intelligence and Machine Learning Club, Sigma Squad! The AI/ML Club aims to foster a supportive and engaging community for students interested in exploring the limitless potential of AI and ML technologies and leveraging them to engage in more real-world problem solving skills and showcase them in Hackathons, Kaggle challenges, Inter IIT competitions, and other open source collaborations.
                </p>
            </div>
        </div>
    )
}

export default SigmaSquadAbout